<script>
    import { preventDefault } from "svelte/legacy";
    import { metricsState, saveMetricsSettings } from "@app/store/metricsStore.svelte.js";
    import * as m from "@app/paraglide/messages.js";

    function updateMetricsSettings() {
        saveMetricsSettings();
    }

    function updateFontSize() {
        metricsState.fontSize = Math.min(
            48,
            Math.max(6, Math.round(Number(metricsState.fontSize) || 12))
        );
        saveMetricsSettings();
    }
</script>

<h5 id="metricsSettingsTitle">{m.options_metrics_title()}</h5>
<p id="metricsSettingsDesc" class="small text-muted">
    {m.options_metrics_desc()}
</p>
<form
    class="mt-4"
    onsubmit={preventDefault(updateMetricsSettings)}
    aria-labelledby="metricsSettingsTitle"
    aria-describedby="metricsSettingsDesc"
>
    <!-- Reading Rate -->
    <div class="row">
        <p class="lead text-warning">{m.options_metrics_section_reading_rate()}</p>
        <div class="col-6">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="cpsIncludeSpacesCheck"
                    bind:checked={metricsState.cpsIncludeSpaces}
                    onchange={updateMetricsSettings}
                    aria-labelledby="cpsIncludeSpacesLabel"
                />
                <label id="cpsIncludeSpacesLabel" class="form-check-label" for="cpsIncludeSpacesCheck"
                    >{m.options_metrics_cps_include_spaces()} <i
                        class="bi bi-info-circle"
                        title={m.options_metrics_cps_include_spaces_help()}
                    ></i></label
                >
            </div>
        </div>
    </div>
    <!-- Editor List Display -->
    <div class="row">
        <p class="lead text-warning">{m.options_metrics_section_display()}</p>
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="metricsFontSize"
                    >{m.options_metrics_font_size()} <i
                        class="bi bi-info-circle"
                        title={m.options_metrics_font_size_help()}
                    ></i></label
                >
                <input
                    class="form-control w-50"
                    type="number"
                    id="metricsFontSize"
                    min="6"
                    max="48"
                    step="1"
                    bind:value={metricsState.fontSize}
                    onchange={updateFontSize}
                />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="showWpmCheck"
                    bind:checked={metricsState.visibleMetrics.wpm}
                    onchange={updateMetricsSettings}
                    aria-labelledby="showWpmLabel"
                />
                <label id="showWpmLabel" class="form-check-label" for="showWpmCheck"
                    >{m.options_metrics_show_wpm()}</label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="showCpsCheck"
                    bind:checked={metricsState.visibleMetrics.cps}
                    onchange={updateMetricsSettings}
                    aria-labelledby="showCpsLabel"
                />
                <label id="showCpsLabel" class="form-check-label" for="showCpsCheck"
                    >{m.options_metrics_show_cps()}</label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="showDurationCheck"
                    bind:checked={metricsState.visibleMetrics.duration}
                    onchange={updateMetricsSettings}
                    aria-labelledby="showDurationLabel"
                />
                <label id="showDurationLabel" class="form-check-label" for="showDurationCheck"
                    >{m.options_metrics_show_duration()}</label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="showWordsCheck"
                    bind:checked={metricsState.visibleMetrics.words}
                    onchange={updateMetricsSettings}
                    aria-labelledby="showWordsLabel"
                />
                <label id="showWordsLabel" class="form-check-label" for="showWordsCheck"
                    >{m.options_metrics_show_words()}</label
                >
            </div>
        </div>
        <div class="col-4">
            <div class="mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="showCharsCheck"
                    bind:checked={metricsState.visibleMetrics.chars}
                    onchange={updateMetricsSettings}
                    aria-labelledby="showCharsLabel"
                />
                <label id="showCharsLabel" class="form-check-label" for="showCharsCheck"
                    >{m.options_metrics_show_chars()}</label
                >
            </div>
        </div>
    </div>
    <!-- Summary Tab -->
    <div class="row">
        <p class="lead text-warning">{m.options_metrics_section_summary()}</p>
        <div class="col-4">
            <div class="mb-3">
                <label class="form-label" for="summaryBarRate"
                    >{m.options_metrics_summary_bar_rate()} <i
                        class="bi bi-info-circle"
                        title={m.options_metrics_summary_bar_rate_help()}
                    ></i></label
                >
                <select
                    id="summaryBarRate"
                    class="form-select"
                    bind:value={metricsState.summaryBarRate}
                    onchange={updateMetricsSettings}
                >
                    <option value="cps">{m.options_metrics_summary_bar_rate_cps()}</option>
                    <option value="wpm">{m.options_metrics_summary_bar_rate_wpm()}</option>
                </select>
            </div>
        </div>
    </div>
</form>
